<mat-card appearance="outlined" STYLE="max-width: 570px; min-width: 350px; margin: 10px;">
  <mat-card-header>
    <div mat-card-avatar>
      <i class="material-icons">
        dynamic_form
      </i>
    </div>
    <mat-card-title>{{this.Form.Name}}</mat-card-title>
    <mat-card-subtitle>
      Version {{this.Form.LatestVersion}}<br/>

    </mat-card-subtitle>

  </mat-card-header>
  <mat-card-content >
    <div>
      @if (this.Form.Visible) {
        <mat-chip >Visible</mat-chip>
        }&nbsp;
        @if (!this.Form.Visible) {
          <mat-chip style="background-color: red;">Hidden</mat-chip>
          }&nbsp;
          @if (!this.Form.MultiEdit) {
            <mat-chip  >Personal</mat-chip>
            }&nbsp;
            @if (this.Form.MultiEdit) {
              <mat-chip  >Multi edit</mat-chip>
              }&nbsp;
              @if (this.Form.AllowCreate) {
                <mat-chip >Open</mat-chip>
                }&nbsp;
                @if (!this.Form.AllowCreate) {
                  <mat-chip  style="background-color: red;" >Closed</mat-chip>
                  }&nbsp;
                  @if (this.Form.FormVersion.PlayerEnabled) {
                    <mat-chip >Player</mat-chip>
                    }&nbsp;
                  </div><br/>
                  <mat-divider></mat-divider>

                  @for (section of this.Form.FormVersion.Sections; track section) {
                    <div style="margin-left: 10px;">
                      [{{section.Text}}  ]
                    </div>
                  }
                  <mat-divider></mat-divider>
                </mat-card-content>
                <mat-card-actions>
                  <button mat-button [routerLink]="['/forms/settings', this.Form.FormId]">SETTINGS</button>
                  <button mat-button [routerLink]="['/forms/edit', this.Form.FormId]">DESIGN</button>
                </mat-card-actions>
              </mat-card>

